/* eslint-disable max-len */

import React from "react"
import BaseSvgIcon from "./Base"

const Close = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path d="M9.9246212,9.21751442 L2.85355339,2.14644661 L2.85355339,2.14644661 C2.65829124,1.95118446 2.34170876,1.95118446 2.14644661,2.14644661 L2.14644661,2.14644661 L2.14644661,2.14644661 C1.95118446,2.34170876 1.95118446,2.65829124 2.14644661,2.85355339 L9.21751442,9.9246212 L2.14644661,16.995689 C1.95118446,17.1909512 1.95118446,17.5075336 2.14644661,17.7027958 C2.34170876,17.8980579 2.65829124,17.8980579 2.85355339,17.7027958 L9.9246212,10.631728 L16.995689,17.7027958 C17.1909512,17.8980579 17.5075336,17.8980579 17.7027958,17.7027958 C17.8980579,17.5075336 17.8980579,17.1909512 17.7027958,16.995689 L10.631728,9.9246212 L17.7027958,2.85355339 C17.8980579,2.65829124 17.8980579,2.34170876 17.7027958,2.14644661 L17.7027958,2.14644661 L17.7027958,2.14644661 C17.5075336,1.95118446 17.1909512,1.95118446 16.995689,2.14644661 L16.995689,2.14644661 L9.9246212,9.21751442 Z" />
    </BaseSvgIcon>
  )
}

export default Close
